import { render, staticRenderFns } from "./migrate_personal.vue?vue&type=template&id=0a2f14c5&"
import script from "./migrate_personal.vue?vue&type=script&lang=js&"
export * from "./migrate_personal.vue?vue&type=script&lang=js&"
import style0 from "./migrate_personal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports